export function searchString(
  source: string | null,
  search: string | null
): boolean {
  if (!search || !source) {
    return false;
  }
  return source.toLowerCase().includes(search);
}
